export enum PurchaseDeliveryTarget {
  PURCHASER = "PURCHASER",
  RECIPIENT = "RECIPIENT",
}
